import { useState, useEffect, useCallback } from 'react';
import { getDevice } from '../utils/api';

export const useDeviceData = (deviceId) => {
	const [device, setDevice] = useState(null);
	const [sensorData, setSensorData] = useState(null);
	const [loading, setLoading] = useState(true);
	const [error, setError] = useState(null);

	const fetchDevice = useCallback(async () => {
		if (!deviceId) {
			setLoading(false);
			return;
		}

		try {
			const response = await getDevice(deviceId);
			if (!response.ok) {
				throw new Error('Device not found');
			}
			const data = await response.json();
			setDevice(data.data);
			setSensorData({
				battery_level: data.data.battery_level,
				water_level: data.data.water_level,
				updated_at: data.data.updated_at
			});
			setError(null);
		} catch (err) {
			setError(err.message);
			console.error(err);
		} finally {
			setLoading(false);
		}
	}, [deviceId]);

	useEffect(() => {
		fetchDevice();
	}, [fetchDevice]);

	const refresh = useCallback(async () => {
		if (!deviceId) return;
		try {
			const response = await getDevice(deviceId);
			if (!response.ok) {
				throw new Error('Failed to refresh device');
			}
			const data = await response.json();
			setDevice(data.data);
			setSensorData({
				battery_level: data.data.battery_level,
				water_level: data.data.water_level,
				updated_at: data.data.updated_at
			});
			setError(null);
		} catch (err) {
			setError(err.message);
			console.error(err);
		}
	}, [deviceId]);

	return { device, sensorData, loading, error, refresh };
};

export default useDeviceData;
